import { makeStyles } from '@material-ui/core';
import appColors from 'utils/appColors';

export default makeStyles({
  root: {
    marginTop: 8,
    minHeight: '100vh',
    backgroundColor: appColors.BACKGROUND_COLOR,
  },
  pagination_control: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 16,
    backgroundColor: appColors.BACKGROUND_COLOR,
  },
  headerCard: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E6E8EB',
    borderRadius: 16,
    padding: '12px 16px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    marginBottom: 8,
  },
  unitsAndFiltersRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 12,
    width: '100%',
  },
  tabsWrapper: {
    flex: '1 1 0',
    minWidth: 0,
    overflow: 'hidden',
    '& .MuiTabs-root': {
      minHeight: 44,
    },
  },
  actionsRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    gap: 8,
    flex: '0 1 auto',
    minHeight: 44,
    maxWidth: '100%',
  },
  actionButton: {
    border: '1px solid #E3E7EE',
    borderRadius: 10,
    backgroundColor: '#F7F9FC',
  },
  emptyStateCard: {
    marginTop: 20,
    borderRadius: 14,
    padding: '28px 24px',
    backgroundColor: '#FFFFFF',
    border: '1px dashed #C9D2DE',
    textAlign: 'center',
  },
  emptyStateTitle: {
    fontFamily: 'Poppins',
    fontSize: 18,
    color: '#25314A',
    fontWeight: 500,
  },
  emptyStateSubtitle: {
    fontFamily: 'Poppins',
    fontSize: 13,
    color: '#667085',
    marginTop: 6,
  },
});
